import { http, httpGet, httpPut, httpPost } from 'shared/services/httpService';
import appSettings from 'shared/settings/appSettings';
import { UserProfile } from 'shared/models/site/user-profile';
import {
    AdminUserModel,
    AdminUserListRequest,
    AdminUserSetStatusRequest,
    IRole,
    IUserSearchResult,
    PagedResult
} from 'shared/models/api/models';

const basePath = '/api/user/';

const fullyQualifiedAndEncodedURL = (relativeUri: string) => {
    return new URL(basePath + encodeURI(relativeUri), appSettings.api.portalApi).toString();
};

const userManagementRoot = fullyQualifiedAndEncodedURL("user-management");

const userDepartmentsPath = new URL('/api/user-management/setDepartment/{DeptId}', appSettings.api.portalApi);

export const searchUserByName = async (searchText: string, pageSize: number): Promise<PagedResult<IUserSearchResult>> => {
    return await httpGet<PagedResult<IUserSearchResult>>(`${fullyQualifiedAndEncodedURL(`search/${searchText}/${pageSize}`).toString()}`);
}

export const searchEmployeeByName = async (searchText: string, pageSize: number): Promise<PagedResult<IUserSearchResult>> => {
    return await httpGet<PagedResult<IUserSearchResult>>(`${fullyQualifiedAndEncodedURL(`employee/search/${searchText}/${pageSize}`).toString()}`);
}

export const searchSupervisorByName = async (searchText: string, pageSize: number): Promise<PagedResult<IUserSearchResult>> => {
    return await httpGet<PagedResult<IUserSearchResult>>(`${fullyQualifiedAndEncodedURL(`supervisor/search/${searchText}/${pageSize}`).toString()}`);
}


export const getAllEmployees = async (): Promise<PagedResult<IUserSearchResult>> => {
    return await httpGet<PagedResult<IUserSearchResult>>(`${fullyQualifiedAndEncodedURL(`employees`).toString()}`);
}

export const getAllUsers = async (): Promise<PagedResult<IUserSearchResult>> => {
    return await httpGet<PagedResult<IUserSearchResult>>(`${fullyQualifiedAndEncodedURL(`allUsers`).toString()}`);
}

export const getAllSupervisors = async (): Promise<PagedResult<IUserSearchResult>> => {
    return await httpGet<PagedResult<IUserSearchResult>>(`${fullyQualifiedAndEncodedURL(`supervisors`).toString()}`);
}

export const setDepartment = async (deptId: number) => {
    return await httpPost<UserProfile>(`${userManagementRoot}/setDepartment/${deptId}`);
}

const getCurrentUserProfilePath = () => { return fullyQualifiedAndEncodedURL('portalweb/profile') };

export const getUserProfile = async () => {
    return await http<UserProfile>(getCurrentUserProfilePath(), "GET")
        .catch((e) => {
            console.log('error getting user profile')
            console.log(e);
            return undefined;
        });
};

export const getAllRoles = async () => {
    return await httpGet<IRole[]>(`${fullyQualifiedAndEncodedURL("allRoles").toString()}`);
}

export const userAdminApi = {
    listAsync: async (req: AdminUserListRequest) =>
        await httpPost<AdminUserModel[]>(`${userManagementRoot}/list`, req),
    getAsync: async (userId: number) =>
        await httpGet<AdminUserModel>(`${userManagementRoot}/get/${userId}`),
    addAsync: async (user: AdminUserModel) =>
        await httpPut<AdminUserModel>(`${userManagementRoot}/add`, user),
    updateAsync: async (user: AdminUserModel) =>
        await httpPost<AdminUserModel>(`${userManagementRoot}/update`, user),
    setStatus: async (req: AdminUserSetStatusRequest) =>
        await httpPost<number>(`${userManagementRoot}/setStatus/`, req)
};